import {Component} from 'react';
import $ from "jquery";
import {hashHistory} from "react-router";

import Analytics from "../../analytics";
import {browserIsSafari} from "../../misc/helpers";

export default class ExpandVisualizerMethods extends Component {

  cameFromBV = () => {
    $("html, body, .bv.body--materials .overlay").animate({scrollTop: 0}, 0);
    this.expandCanvas(() => {
      const rect = document.querySelector(".selection-main__image").parentElement.getBoundingClientRect();
      this.setState({
        canvasExpanding: false,
        canvasCollapsing: true,
        canvasImageStyles: {
          transition: "all 0.5s ease",
          position: "fixed",
          left: 0,
          top: 0,
          transform: "translate("+rect.left+"px, "+rect.top+"px)",
          width: rect.width + "px",
          height: rect.height + "px",
          zIndex: 9999,
        }
      }, () => {
        setTimeout(() => {
          this.setState({
            canvasCollapsing: false,
            canvasImageStyles: {}
          }, () => {
            const mobileSafari = (this.props.windowWidth < 991) && browserIsSafari();
            if (mobileSafari) {
              $("html, body, .bv.body--materials .overlay").animate({scrollTop: 0}, 300);
            }
          });
        }, 500)
      })
    });
  };

  goToBV = () => {
    Analytics.sendClickEvent('go-to-bathroom-visualizer');
    const canvasImageDiv = document.querySelector(".selection-main__image");
    const rect = canvasImageDiv.getBoundingClientRect();
    this.props.setBathroomVisualizerVisited();
    this.setState({
      canvasLoading: true,
      canvasImageStyles: {
        position: "fixed",
        left: 0,
        top: 0,
        transform: "translate("+rect.left+"px, "+rect.top+"px)",
        width: rect.width + "px",
        height: rect.height + "px",
        zIndex: 9999,
      }
    }, () => {
      setTimeout(() => {
        this.expandCanvas(() => {
          // if (this.props.windowWidth < 991) {
          //   $(canvasImageDiv).animate({
          //     scrollTop: canvasImageDiv.scrollHeight / 4
          //   }, 500);
          // }
          setTimeout(() => {
            this.props.toggleBathroomVisualizerOpen(true);
            hashHistory.push('visualizer');
            this.props.toggleSelectionFeatureInfo(null);
            if (!this.props.visualizerTutorialFinished) {
              this.props.showVisualizerTutorial(true);
            }
          }, 500)
        })
      }, 0)
    });
  };

  expandCanvas = (callBack = () => {}) => {
    const wideScreen = this.props.windowWidth > 1620;
    const bigScreen = this.props.windowWidth > 991 && window.innerHeight > 1080;
    this.setState({
      canvasLoading: false,
      canvasExpanding: true,
      canvasImageStyles: {
        transition: "all 0.5s ease",
        position: "fixed",
        left: wideScreen ? "50%" : 0,
        marginLeft: wideScreen ? "-810px": 0,
        top: 0,
        transform: "none",
        width: wideScreen ? "1620px" : "100%",
        height: "100%",
        zIndex: 9999,
        padding: bigScreen ? 0 : "0 4px"
      }
    }, () => {
      callBack()
    })
  };

}
